var myStorage = Object.create(MyStorage).constructor();